module.exports = __webpack_public_path__ + "img/hand-right-top.260141cf.png";